/* eslint-disable */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { mockBlogs } from '../data/blogsData';

const SiteContentContext = createContext();

const API_BASE = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

export const DEFAULT_SITE_CONTENT = {
  hero: {
    badge: "",
    titleLine1: "",
    titleLine2: "",
    titleLine3: "",
    subtitle: "",
    primaryBtnText: "",
    secondaryBtnText: "",
    heroImage: "",
    rating: "",
    clientCount: ""
  },
  about: {
    badge: "About RojrzTech",
    heading: "Empowering Your Digital Journey",
    desc1: "We are a fully registered LLC and a premier software and digital marketing agency. Our mission is to transform your vision into reality through cutting-edge technology, innovative design, and data-driven marketing strategies.",
    desc2: "Whether you need a powerful web application, a seamless mobile app, or a complete digital brand overhaul, we have the expertise to deliver scalable solutions that drive real business growth.",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2070&auto=format&fit=crop"
  },
  servicesHeader: {
    badge: "Our Services",
    titlePrefix: "RojrzTech: Your",
    titleHighlight: "Integrated Digital",
    titleSuffix: "Solutions Partner",
    subtitle: "At RojrzTech, we provide a full spectrum of digital services — all under one roof."
  },
  contact: {
    badge: "Let's Collaborate",
    heading: "Ready To Build Your Next Venture?",
    address: "5900, Balcones Drive, STE 100, Austin, Texas, 78731",
    email: "info@rojrztech.com",
    phone: "+1 (512) 254-4193"
  },
  cta: {
    badge: "Let's Make Magic Happen",
    titleLine1: "Have a Great Idea?",
    titleLine2: "Let's Build It",
    titleLine3: "Into Reality.",
    subtitle: "Stop waiting for the perfect time. Drop us a message today, schedule a strategy deployment call, and turn your technical vision into high-yield code.",
    primaryBtnText: "Get Started Now"
  },

  // Service Pages (Tab IDs matching Admin Dashboard)
  'svc-web-mobile': {
    badge: "WEB & MOBILE APPS",
    title: "Custom High-Performance Web & Mobile Applications",
    subtitle: "We build ultra-fast, responsive web apps (React, Next.js) and native mobile apps (iOS & Android) engineered for maximum scale and conversion."
  },
  'svc-cms-ecom': {
    badge: "SHOPIFY & E-COMMERCE",
    title: "High-Converting Online Stores & E-Commerce Solutions",
    subtitle: "Turn visitors into repeat customers with custom Shopify stores, WooCommerce, and tailored online checkout funnels."
  },
  'svc-digital-mkt': {
    badge: "DIGITAL MARKETING & SMM",
    title: "Data-Driven Marketing & Social Media Growth",
    subtitle: "Scale your revenue with high-ROI Meta & Google Ad campaigns, social media management, and targeted lead generation."
  },
  'svc-graphic-video': {
    badge: "GRAPHIC DESIGN & VIDEO",
    title: "Stunning Graphic Design & Motion Video Editing",
    subtitle: "Elevate your visual identity with custom logo concepts, brand books, promotional video edits, and 2D/3D animation."
  },
  'svc-ui-ux': {
    badge: "UI/UX DESIGN",
    title: "User-Centric UI/UX Design & Interactive Prototypes",
    subtitle: "We craft intuitive wireframes, Figma design systems, and delightful digital user interfaces."
  },
  'svc-ai-tech': {
    badge: "AI TECHNOLOGIES",
    title: "Custom AI Chatbots & Intelligent Automation",
    subtitle: "Integrate smart AI agents, automated customer support workflows, and machine learning models into your business."
  },
  'svc-support': {
    badge: "24/7 CUSTOMER SUPPORT",
    title: "Dedicated Technical Support & Ticketing Systems",
    subtitle: "Ensure 99.9% uptime with 24/7 website maintenance, security monitoring, and dedicated support agents."
  },

  // Industry Pages (Tab IDs matching Admin Dashboard)
  'ind-healthcare': {
    title: "Healthcare & Telemedicine Solutions",
    subtitle: "HIPAA-compliant web apps, patient portals, and appointment scheduling systems for medical practices."
  },
  'ind-fitness': {
    title: "Fitness & Gym App Development",
    subtitle: "Workout tracking, membership management, and online class booking platforms for fitness brands."
  },
  'ind-home-svc': {
    title: "Home Services & Contracting Websites",
    subtitle: "Lead generation websites for plumbers, electricians, HVAC contractors, and home improvement pros."
  },
  'ind-real-estate': {
    title: "Real Estate & Property Platforms",
    subtitle: "MLS listing integrations, property virtual tours, and CRM tools for real estate brokers and agents."
  },
  'ind-ecommerce': {
    title: "Retail & E-Commerce Platforms",
    subtitle: "Scalable online storefronts with automated inventory and multi-channel sales integrations."
  },
  'ind-restaurant': {
    title: "Restaurant & Food Delivery Systems",
    subtitle: "Online food ordering systems, digital QR menus, and table reservation web apps."
  },
  'ind-coaching': {
    title: "Coaching & Mentorship Portals",
    subtitle: "Course delivery systems, student portals, and video subscription platforms for coaches."
  },
  'ind-education': {
    title: "EdTech & Learning Management Systems (LMS)",
    subtitle: "Interactive virtual classrooms, quiz engines, and student progress dashboards."
  },

  caseStudies: {
    title: "Featured Case Studies",
    subtitle: "Explore our latest web design, branding, and mobile app projects."
  },

  portfolioItems: [
    { id: 1, title: 'Corporate Identity', category: 'Logo', img: 'https://images.unsplash.com/photo-1572044162444-ad60f128bdea?auto=format&fit=crop&q=80&w=800' },
    { id: 2, title: 'Modern UI/UX', category: 'Website Design', img: 'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?auto=format&fit=crop&q=80&w=800' },
    { id: 3, title: 'Brand Strategy', category: 'Corporate Branding', img: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?auto=format&fit=crop&q=80&w=800' },
    { id: 4, title: 'Sales Funnel', category: 'E-Commerce', img: 'https://images.unsplash.com/photo-1557821552-17105176677c?auto=format&fit=crop&q=80&w=800' },
    { id: 5, title: 'Promo Video', category: 'Video', img: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&q=80&w=800' },
    { id: 6, title: 'Motion Graphic', category: 'Animation', img: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&q=80&w=800' },
    { id: 7, title: 'Logo Design', category: 'Logo', img: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?auto=format&fit=crop&q=80&w=800' },
    { id: 8, title: 'Web App', category: 'Website Design', img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800' },
    { id: 9, title: 'Brand Identity', category: 'Corporate Branding', img: 'https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&q=80&w=800' },
    { id: 10, title: 'E-Store Design', category: 'E-Commerce', img: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&q=80&w=800' },
    { id: 11, title: 'Brand Video', category: 'Video', img: 'https://images.unsplash.com/photo-1536240478700-b869ad10e097?auto=format&fit=crop&q=80&w=800' },
    { id: 12, title: '2D Animation', category: 'Animation', img: 'https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?auto=format&fit=crop&q=80&w=800' },
  ]
};

// ─── Helper: Load from localStorage (live bridge) ─────────────────────
const loadLocalContent = () => {
  try {
    const saved = localStorage.getItem('rojrztech_site_content');
    return saved ? JSON.parse(saved) : null;
  } catch { return null; }
};

const saveLocalContent = (content) => {
  try {
    localStorage.setItem('rojrztech_site_content', JSON.stringify(content));
  } catch {}
};

const loadLocalSettings = () => {
  try {
    const saved = localStorage.getItem('rojrztech_site_settings');
    return saved ? JSON.parse(saved) : null;
  } catch { return null; }
};

const saveLocalSettings = (settings) => {
  try {
    localStorage.setItem('rojrztech_site_settings', JSON.stringify(settings));
  } catch {}
};

export const SiteContentProvider = ({ children }) => {
  // Initialize from localStorage immediately (live bridge) → then sync from MySQL
  const localContent = loadLocalContent();
  const [siteContent, setSiteContent] = useState(localContent ? { ...DEFAULT_SITE_CONTENT, ...localContent } : DEFAULT_SITE_CONTENT);

  const [blogs, setBlogs] = useState(mockBlogs);

  const localSettings = loadLocalSettings();
  const [siteSettings, setSiteSettings] = useState({
    logoText: 'RojrzTech',
    logoImageUrl: '',
    metaPixelId: '',
    googleAnalyticsId: '',
    headerScript: '',
    footerScript: '',
    ...(localSettings || {})
  });
  const [loading, setLoading] = useState(true);

  // Fetch live dynamic content, settings & blogs from MySQL backend API
  const fetchAllData = async () => {
    try {
      // 1. Fetch Site Section Content
      const contentRes = await fetch(`${API_BASE}/api/content`);
      if (contentRes.ok) {
        const contentData = await contentRes.json();
        if (contentData.success && contentData.content && Object.keys(contentData.content).length > 0) {
          const merged = { ...DEFAULT_SITE_CONTENT, ...localContent, ...contentData.content };
          setSiteContent(merged);
          saveLocalContent(merged); // Keep localStorage in sync with MySQL
        }
      }

      // 2. Fetch Blogs
      const blogsRes = await fetch(`${API_BASE}/api/blogs`);
      if (blogsRes.ok) {
        const blogsData = await blogsRes.json();
        if (blogsData.success && Array.isArray(blogsData.blogs) && blogsData.blogs.length > 0) {
          setBlogs(blogsData.blogs);
        }
      }

      // 3. Fetch Settings (Logo, Meta Pixel, Scripts)
      const settingsRes = await fetch(`${API_BASE}/api/settings`);
      if (settingsRes.ok) {
        const settingsData = await settingsRes.json();
        if (settingsData.success && settingsData.settings) {
          const merged = { ...siteSettings, ...settingsData.settings };
          setSiteSettings(merged);
          saveLocalSettings(merged); // Keep localStorage in sync with MySQL
        }
      }

      // 4. Fetch Home Page Hero
      const heroRes = await fetch(`${API_BASE}/api/v1/page-heroes/home`);
      if (heroRes.ok) {
        const heroData = await heroRes.json();
        if (heroData.success && heroData.hero) {
          setSiteContent((prev) => {
            const updated = { ...prev, hero: { ...prev.hero, ...heroData.hero } };
            saveLocalContent(updated);
            return updated;
          });
        }
      }
    } catch (err) {
      console.warn('⚠️ CMS API offline — using localStorage + defaults:', err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  // Update Section Content — saves to state + localStorage (instant) + MySQL (persistent)
  const saveSectionContent = async (sectionKey, newContent) => {
    // 1. Instant local update → public pages see changes immediately
    setSiteContent((prev) => {
      const updated = { ...prev, [sectionKey]: newContent };
      saveLocalContent(updated); // Write to localStorage bridge
      return updated;
    });

    // 2. Persist to MySQL in background
    try {
      const response = await fetch(`${API_BASE}/api/admin/content`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sectionKey, content: newContent }),
      });
      const data = await response.json();
      if (data.success) {
        return { success: true, message: '✅ Saved to database + live site updated!' };
      } else {
        return { success: true, message: '✅ Saved locally! (DB: ' + data.error + ')' };
      }
    } catch (err) {
      console.warn('MySQL offline — data saved to localStorage:', err.message);
      return { success: true, message: '✅ Saved locally! Changes visible on site immediately.' };
    }
  };

  // Add / Update Blog in MySQL Backend
  const saveBlog = async (blogData, isEdit = false) => {
    const endpoint = isEdit ? `${API_BASE}/api/admin/blogs/${blogData.id}` : `${API_BASE}/api/admin/blogs`;
    const method = isEdit ? 'PUT' : 'POST';

    try {
      const response = await fetch(endpoint, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(blogData),
      });
      const data = await response.json();
      if (data.success) {
        await fetchAllData();
        return { success: true, message: data.message };
      } else {
        throw new Error(data.error);
      }
    } catch (err) {
      console.error('Failed to save blog:', err);
      return { success: false, error: err.message };
    }
  };

  // Delete Blog in MySQL Backend
  const deleteBlog = async (blogId) => {
    try {
      const response = await fetch(`${API_BASE}/api/admin/blogs/${blogId}`, {
        method: 'DELETE',
      });
      const data = await response.json();
      if (data.success) {
        setBlogs((prev) => prev.filter((b) => b.id !== blogId));
        return { success: true, message: data.message };
      } else {
        throw new Error(data.error);
      }
    } catch (err) {
      console.error('Failed to delete blog:', err);
      setBlogs((prev) => prev.filter((b) => b.id !== blogId));
      return { success: true, message: 'Deleted locally.' };
    }
  };

  // Save Site Setting — instant localStorage + MySQL background sync
  const saveSiteSetting = async (key, value) => {
    // 1. Instant update to state + localStorage
    setSiteSettings((prev) => {
      const updated = { ...prev, [key]: value };
      saveLocalSettings(updated);
      return updated;
    });

    // 2. Persist to MySQL
    try {
      const response = await fetch(`${API_BASE}/api/admin/settings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, value }),
      });
      const data = await response.json();
      if (data.success) {
        return { success: true, message: '✅ Setting saved to database!' };
      } else {
        return { success: true, message: '✅ Saved locally (DB: ' + data.error + ')' };
      }
    } catch (err) {
      console.warn('MySQL offline — setting saved locally:', err.message);
      return { success: true, message: '✅ Saved locally!' };
    }
  };

  return (
    <SiteContentContext.Provider
      value={{
        siteContent,
        blogs,
        siteSettings,
        loading,
        saveSectionContent,
        saveBlog,
        deleteBlog,
        saveSiteSetting,
        refreshData: fetchAllData,
      }}
    >
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
